import { createElement, forwardRef } from 'react';
import { aspectRatio } from '../patterns/aspect-ratio.js';
import { splitProps } from '../helpers.js';
import { styled } from './factory.js';

export const AspectRatio = /* @__PURE__ */ forwardRef(function AspectRatio(props, ref) {
  const [patternProps, restProps] = splitProps(props, aspectRatio.propKeys)
  const styleProps = aspectRatio.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})